import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import API from "../utils/api";

export default function AutoLoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const autoLogin = async () => {
      try {
        const token = searchParams.get("token");

        if (!token) {
          return navigate("/", { replace: true });
        }

        // VERIFY TOKEN + GET USER
        const res = await API.post("/auth/verify-token", {
          token,
        });

        // EXACT SAME AS REACT LOGIN
        localStorage.setItem(
          "user",
          JSON.stringify(res.data)
        );

        // GO TO HOME
        navigate("/home", { replace: true });

      } catch (err) {
        console.log(err);
        navigate("/", { replace: true });
      }
    };

    autoLogin();
  }, []);

  return <div>Loading...</div>;
}